(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["andriali-professional"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-andriali-inquiry]').forEach((container)=>{
const query=new URLSearchParams(location.search);
const fieldFor=(name)=>container.querySelector('[name="contact['+name+']"]');
['product','color','application','source','request_type'].forEach((key)=>{
const field=fieldFor(key);const value=query.get(key);
if(field&&value&&value.length<400&&!(key==='request_type'&&!['sample','documents','project'].includes(value)))field.value=value;
});
const update=()=>{
const type=fieldFor('request_type').value;
container.querySelector('[data-document-field]').hidden=type!=='documents';
fieldFor('document_type').disabled=type!=='documents';
const notice=container.querySelector('[data-sample-notice]');
notice.hidden=type!=='sample';
const button=container.querySelector('[data-send-request]');
if(type==='sample')button.setAttribute('aria-describedby',notice.id);else button.removeAttribute('aria-describedby');
};
fieldFor('request_type').addEventListener('change',update);update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
